import script from "./CModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CModal.vue?vue&type=script&lang=ts&setup=true"

import "./CModal.vue?vue&type=style&index=0&id=605bd14e&scoped=true&lang=scss"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605bd14e"]])

export default __exports__